import React from "react";
import { Button } from "@dpdgroupuk/mydpd-ui";
import PropTypes from "prop-types";
import { compose } from "redux";
import { withProps } from "recompose";
import { withRouter } from "react-router";
import { trackProps, withTrack, withTrackProps } from "@dpdgroupuk/react-event-tracker";
import { ConfirmIcon } from "../../../../components/Icon";
import { ROUTE, ANALYTICS } from "../../../../constants";
import styles from "./PasswordChangeSuccess.module.scss";

const PasswordChangeSuccess = ({
  onDone
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.container
}, /*#__PURE__*/React.createElement(ConfirmIcon, null), /*#__PURE__*/React.createElement("h1", {
  className: styles.heading
}, "Password change successful"), /*#__PURE__*/React.createElement("p", null, "Your password change was successful and is now ready for you to use."), /*#__PURE__*/React.createElement(Button, {
  id: "submitBtn",
  type: "submit",
  variant: "primary",
  className: styles.button,
  onClick: onDone
}, "Done"));

PasswordChangeSuccess.propTypes = {
  onDone: PropTypes.func
};
export default compose(withRouter, withProps(props => ({
  onDone: () => props.history.push({
    pathname: ROUTE.LOGON_PAGE,
    search: props.location.search
  })
})), withTrack(trackProps(ANALYTICS.PASSWORD_CHANGE_SUCCESS_PAGE)), withTrackProps({
  onDone: ANALYTICS.PASSWORD_CHANGE_SUCCESS_PAGE.ON_CLICK_DONE
}))(PasswordChangeSuccess);